import React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface ConsentModalProps {
  show: boolean
  header: string
  body: string | React.ReactNode
  onAgree: () => void
  onBack: () => void
  onHide: () => void
}

const ConsentModal: React.FC<ConsentModalProps> = ({
  show,
  header,
  body,
  onAgree,
  onBack,
  onHide,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onBack}>
          Zpět
        </Button>
        <Button variant="primary" onClick={onAgree}>
          Souhlasím
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConsentModal
